var app;

app = window.App || (window.App = {});

app.DatePeriodValidator = (function() {
  var dateFormats;

  dateFormats = ['YYYY/MM/DD', 'YYYY-MM-DD', 'YYYY.MM.DD', 'D/M/YY', 'D\M\YY', 'D-M-YY', 'DD-MM-YYYY', 'D.M.YY', 'D.M.YYYY', 'DD.MM.YYYY', 'D MMM YY'];

  function DatePeriodValidator(event) {
    this._container = $(event.target).closest('.date-period-validated');
    this._fields = $(event.target).closest('.fields');
    if (this._fields.length === 0) {
      this._fields = this._container;
    }
    this._startAtFields = this._findFields(0, 0);
    this._finishAtFields = this._findFields(1, 2);
  }

  DatePeriodValidator.prototype.validate = function() {
    var finishAt, startAt;
    this._clearErrors();
    startAt = this._parseDate(this._startAtFields);
    finishAt = this._parseDate(this._finishAtFields);
    this._validateDate(startAt, this._container.data('start-at-invalid-message'), this._startAtFields);
    this._validateDate(finishAt, this._container.data('finish-at-invalid-message'), this._finishAtFields);
    return this._validateDateOrder(startAt, finishAt, this._container.data('before-message'), this._finishAtFields);
  };

  DatePeriodValidator.prototype._findFields = function(dateOffset, timeOffset) {
    var dateField;
    dateField = $('.date:nth(' + dateOffset + ')', this._fields);
    return [dateField, $('.time:nth(' + timeOffset + ')', this._fields), $('.time:nth(' + (timeOffset + 1) + ')', this._fields), dateField.closest('.control-group')];
  };

  DatePeriodValidator.prototype._clearErrors = function() {
    this._startAtFields[3].removeClass('error');
    this._finishAtFields[3].removeClass('error');
    return $('.help-inline', this._fields).remove();
  };

  DatePeriodValidator.prototype._parseDate = function(fields) {
    if (fields[0].val().trim()) {
      return moment.utc(fields[0].val().trim(), dateFormats, true).set({
        hour: fields[1].val(),
        minute: fields[2].val()
      });
    }
  };

  DatePeriodValidator.prototype._validateDate = function(date, message, fields) {
    if (date && !date.isValid()) {
      return this._addError(message, fields);
    }
  };

  DatePeriodValidator.prototype._validateDateOrder = function(startAt, finishAt, message, fields) {
    if (startAt && startAt.isValid() && finishAt && finishAt.isValid() && !startAt.isSame(finishAt) && !startAt.isBefore(finishAt)) {
      return this._addError(message, fields);
    }
  };

  DatePeriodValidator.prototype._addError = function(message, fields) {
    var lastField;
    lastField = fields[2].length > 0 ? fields[2] : fields[0].parent();
    $('<span class="help-inline">' + message + '</span>').insertAfter(lastField);
    return fields[3].addClass('error');
  };

  return DatePeriodValidator;

})();

$(document).on('change', '.date-period-validated .date, .date-period-validated .time', function(event) {
  return new app.DatePeriodValidator(event).validate();
});
